import React from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';
import { GearIcon } from '@radix-ui/react-icons';


const FieldTypeSelect = ({ options, onChange }) => {

    const DropdownIndicator = (props) => (
        <components.DropdownIndicator {...props}>
            <GearIcon color='black' className='GearIcon'/>
        </components.DropdownIndicator>
    );

    return (
        <div>
            <Select
                options={options}
                className='FieldTypeSelect'
                onChange={(e) => onChange(e)}
                components={{ DropdownIndicator }}
                isSearchable={false}
                placeholder={''}
                value={null}

                styles={{
                    indicatorSeparator: () => ({ display: 'none' }),
                    valueContainer: () => ({ display: 'none' }),
                    menu: (base) => ({
                        ...base,
                        width: 'max-content',
                        minWidth: '100%'
                    }),
                    control: () => { }
                }}

            />
        </div>
    );
};

FieldTypeSelect.defaultProps = {
};

FieldTypeSelect.propTypes = {
    options: PropTypes.object,
    onChange: PropTypes.func,
};

export default FieldTypeSelect;